<template>
  <div>
    <div>
      <div class="d-flex align-items-center"><span class="ml-2 mb-3 label-bold color-dark-purple">HABILIDADES TÉCNICAS</span></div>
      <vue-tags-input
        v-model="skill"
        class="full mt-1"
        :tags="skills"
        @before-deleting-tag="deleteSkill"
        @before-adding-tag="createSkill($event, 0)"
        :autocomplete-items="autocompleteItemsSkill"
        @tags-changed="(newTags) => (skills = newTags)"
      />
      <span class="f12">
        CASO QUEIRA, ADICIONE HABILIDADES TÉCNICAS OU COMPORTAMENTAIS AO SEU PERFIL. PRESSIONE <b>ENTER</b> PARA ADICIONAR.
      </span>
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  components: { VueTagsInput },
  data: () => ({
    skill: "",
    skills: [],
    autocompleteItemsSkill: [],
  }),
  watch: {
    skill: "searchSkills",
  },
  mounted() {
    this.setSkills();
  },
  methods: {
    searchSkills() {
      axios
        .get(`/candidates/candidate_skills/search?term=${this.skill}`)
        .then((response) => {
          this.autocompleteItemsSkill = response.data.skills;
        });
    },
    createSkill(obj, input) {
      if (obj.tag.tiClasses.includes("ti-duplicate")) {
        this.$toast.error("Habildade duplicada");
        return;
      }

      let skills = {
        name: obj.tag.text.trim(),
        skill_id: obj.tag.skill_id,
      };

      axios
        .post("/candidates/candidate_skills", { skills })
        .then((response) => {
          if (response.status) {
            obj.tag.id = response.data.skill.id;
            obj.addTag();
            return;
          }
          this.$toast.error("Não foi possivel adicionar habilidade");
        });
    },
    deleteSkill(obj) {
      axios
        .delete(`/candidates/candidate_skills/${obj.tag.id}`)
        .then((response) => {
          if (response.data.status) obj.deleteTag();
        });
    },
    setSkills() {
      axios.get(`/candidates/candidate_skills/`).then((response) => {
        let skills_current = response.data.skills;
        if (skills_current.length == 0) return;
        for (let skill of skills_current) {
          this.skills.push({
            id: skill.id,
            text: skill.name,
            tiClasses: ["ti-valid"],
          });
        }
      });
    },
  },
};
</script>
